__turbopack_context__.v({
  "ShareModal": "ShareModal-module__NAYCcq__ShareModal",
  "closeButton": "ShareModal-module__NAYCcq__closeButton",
  "contents": "ShareModal-module__NAYCcq__contents",
  "copy": "ShareModal-module__NAYCcq__copy",
  "instagramButton": "ShareModal-module__NAYCcq__instagramButton",
  "messengerButton": "ShareModal-module__NAYCcq__messengerButton",
  "overlay": "ShareModal-module__NAYCcq__overlay",
  "popIn": "ShareModal-module__NAYCcq__popIn",
  "row": "ShareModal-module__NAYCcq__row",
  "text": "ShareModal-module__NAYCcq__text",
  "text2": "ShareModal-module__NAYCcq__text2",
});
